<template>
<div class='swiper-wrapper' v-show='products.length != 0'>
    <template v-for='product in products' :key='product.code'>
        <div class="swiper-slide product-card">
            <ProductCard :product='product' :page_builder_mode='page_builder_mode'/>
        </div>
    </template>
</div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import ProductCard from '@/ecom/components/products/ProductCard.vue';
import {checkAuth} from "@/global/modules/functions.js";
import Loading from '@/ecom/components/loading/Loading.vue';

export default {
    components: {DynamicImageContainer, ProductCard, Loading},
    props: ['element', 'page_builder_mode', 'selected_carousel_slide'],
    emits: ['selectedCarouselTypeListener'],
    data(){
        return{
            products: [],
            loading: true
        }
    },
    methods:{
        slideClick(slide){
            if(!this.page_builder_mode){
                if(slide.url != ''){
                    this.$router.push(slide.url);
                }
            }
        },
        async getProducts(){
            this.loading = true;

            let product_ids = this.element.element_config.product_slides.map((x)=>{
                return x.id;
            });

            let response = await fetch(`/api/products/get-by-ids?products=${JSON.stringify(this.element.element_config.product_slides)}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.products = results;
                this.loading = false;
                this.$emit('selectedCarouselTypeListener', this.products);
            }
        },
    },
    mounted(){
        this.getProducts();
    },
    watch: {
        'element.element_config.product_slides': {
            handler(){
                this.getProducts();
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.product-card{
    width: var(--product-card-width);
}

.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 20px;
}
</style>